export function SellMyApartmentFinalCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-orange-50 to-red-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ready to Sell Your Apartment Building?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
            Get your free, no-obligation cash offer today. We've helped hundreds of apartment building owners 
            across the country sell quickly and hassle-free.
          </p>
          
          <div className="bg-white rounded-xl shadow-lg p-12 mb-16">
            <img 
              src="https://public.readdy.ai/ai/img_res/afb6d4a8659f862bc6bcc42774d1720d.jpg"
              alt="Successful apartment building sale handshake"
              className="w-full h-64 object-cover rounded-lg mb-8"
            />
            
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-4xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">24 Hour Response</h3>
                <p className="text-gray-600">
                  Get your cash offer within 24 hours of submitting your property information. 
                  No waiting weeks for responses.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-4xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">No Obligations</h3>
                <p className="text-gray-600">
                  Our offer comes with zero obligations. Take time to consider our proposal 
                  with no pressure or commitment.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-dollar-circle-line text-4xl text-purple-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Fair Market Price</h3>
                <p className="text-gray-600">
                  We provide competitive offers based on current market conditions and 
                  your property's true potential value.
                </p>
              </div>
            </div>

            <div className="bg-orange-50 rounded-xl p-8 mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                What Our Clients Say
              </h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-lg shadow-sm">
                  <div className="flex items-center mb-4">
                    <div className="flex text-yellow-400">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 italic">
                    "They closed in 12 days exactly as promised. Professional, fair, and stress-free process. 
                    Highly recommend for anyone needing to sell quickly."
                  </p>
                  <p className="text-sm font-semibold text-gray-900">- Michael R., Chicago IL</p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-sm">
                  <div className="flex items-center mb-4">
                    <div className="flex text-yellow-400">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 italic">
                    "Sold our 24-unit building with tenants in place. They handled everything professionally 
                    and tenants were happy with the transition."
                  </p>
                  <p className="text-sm font-semibold text-gray-900">- Sarah M., Phoenix AZ</p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-sm">
                  <div className="flex items-center mb-4">
                    <div className="flex text-yellow-400">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 italic">
                    "Fair offer for our as-is property. No repairs needed, no commissions, and we avoided foreclosure. 
                    Thank you for the lifeline!"
                  </p>
                  <p className="text-sm font-semibold text-gray-900">- David L., Miami FL</p>
                </div>
              </div>
            </div>

            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-8">
                Get Your Free Cash Offer Now
              </h3>
              <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
                <button className="bg-orange-500 hover:bg-orange-600 text-white px-12 py-4 rounded-lg font-semibold text-xl whitespace-nowrap shadow-lg">
                  Get Cash Offer Online
                </button>
                <div className="text-gray-500 text-lg">or</div>
                <button className="border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-12 py-4 rounded-lg font-semibold text-xl whitespace-nowrap">
                  Call (555) 123-4567
                </button>
              </div>
              
              <div className="grid md:grid-cols-4 gap-4 text-sm text-gray-600">
                <div className="flex items-center justify-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span>No Repairs Required</span>
                </div>
                <div className="flex items-center justify-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span>No Commissions</span>
                </div>
                <div className="flex items-center justify-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span>Fast 7-30 Day Closing</span>
                </div>
                <div className="flex items-center justify-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span>Any Condition</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-900 rounded-xl p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">
            Frequently Asked Questions
          </h3>
          <div className="grid md:grid-cols-2 gap-8 text-left max-w-4xl mx-auto">
            <div>
              <h4 className="text-lg font-semibold mb-3">How quickly can you close?</h4>
              <p className="text-gray-300 mb-6">
                We can close in as little as 7 days for emergency situations, with most closings happening 
                within 7-30 days depending on your timeline preferences.
              </p>
              
              <h4 className="text-lg font-semibold mb-3">Do you buy properties in any condition?</h4>
              <p className="text-gray-300 mb-6">
                Yes, we purchase apartment buildings in any condition including those needing major repairs, 
                with problem tenants, or facing foreclosure.
              </p>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-3">Are there any fees or commissions?</h4>
              <p className="text-gray-300 mb-6">
                No, we don't charge any fees or commissions. The offer we present is the amount 
                you'll receive at closing.
              </p>
              
              <h4 className="text-lg font-semibold mb-3">How do you determine your offer price?</h4>
              <p className="text-gray-300 mb-6">
                We analyze market comparables, rental income, expenses, property condition, and required improvements 
                to provide a fair market-based offer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}